export const PASSBOOK_PIC = 'passbook_pic';



// WEBPACK FOOTER //
// ./src/constants/bankField.js